import { GlLink, GlPopover, GlTooltipDirective } from '@gitlab/ui';
import PolicyApprovalSettingsIcon from 'ee_component/vue_merge_request_widget/components/approvals/policy_approval_settings_icon.vue';
import { toNounSeriesText } from '~/lib/utils/grammar';
import { n__, s__, sprintf } from '~/locale';
import { APPROVED_BY_YOU_AND_OTHERS, APPROVED_BY_YOU, APPROVED_BY_OTHERS } from '~/vue_merge_request_widget/components/approvals/messages';
import HelpIcon from '~/vue_shared/components/help_icon/help_icon.vue';
import UserAvatarList from '~/vue_shared/components/user_avatar/user_avatar_list.vue';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { getApprovalRuleNamesLeft } from 'ee_else_ce/vue_merge_request_widget/mappers';
export default {
    name: 'ApprovalsSummary',
    components: {
        GlLink,
        GlPopover,
        HelpIcon,
        UserAvatarList,
        PolicyApprovalSettingsIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        optional: {
            type: Boolean,
            required: true
        },
        multipleApprovalRulesAvailable: {
            type: Boolean,
            required: false,
            default: false
        },
        approvalState: {
            type: Object,
            required: true
        },
        disableCommittersApproval: {
            type: Boolean,
            required: false,
            default: false
        },
        canApprove: {
            type: Boolean,
            required: true
        },
        helpPath: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            isUserAvatarListExpanded: false
        };
    },
    computed: {
        approvers () {
            return this.approvalState.approvedBy?.nodes || [];
        },
        approved () {
            return this.approvalState.approved || this.approvalState.approvedBy?.nodes.length > 0;
        },
        approvalsLeft () {
            return this.approvalState.approvalsLeft || 0;
        },
        rulesLeft () {
            return getApprovalRuleNamesLeft(this.multipleApprovalRulesAvailable, (this.approvalState.approvalState?.rules || []).filter((r)=>!r.approved));
        },
        approvalLeftMessage () {
            if (this.optional) return s__('mrWidget|Approval is optional');
            if (this.rulesLeft.length) {
                return sprintf(n__('Requires %{count} approval from %{names}.', 'Requires %{count} approvals from %{names}.', this.approvalsLeft), {
                    names: toNounSeriesText(this.rulesLeft),
                    count: this.approvalsLeft
                }, false);
            }
            if (!this.approved) {
                return n__('Requires %d approval from eligible users.', 'Requires %d approvals from eligible users.', this.approvalsLeft);
            }
            return '';
        },
        message () {
            if (this.approvedByMe && this.approvedByOthers) {
                return APPROVED_BY_YOU_AND_OTHERS;
            }
            if (this.approvedByMe) {
                return APPROVED_BY_YOU;
            }
            if (this.approved) {
                return APPROVED_BY_OTHERS;
            }
            return '';
        },
        hasApprovers () {
            return Boolean(this.approvers.length);
        },
        approvedByMe () {
            if (!this.currentUserId) {
                return false;
            }
            return this.approvers.some((approver)=>getIdFromGraphQLId(approver.id) === this.currentUserId);
        },
        approvedByOthers () {
            if (!this.currentUserId) {
                return false;
            }
            return this.approvers.some((approver)=>getIdFromGraphQLId(approver.id) !== this.currentUserId);
        },
        currentUserHasCommitted () {
            if (!this.currentUserId) return false;
            return this.approvalState.committers?.nodes?.some((user)=>getIdFromGraphQLId(user.id) === this.currentUserId);
        },
        currentUserId () {
            return gon.current_user_id;
        },
        policiesOverridingApprovalSettings () {
            return this.approvalState.policiesOverridingApprovalSettings;
        }
    },
    methods: {
        onUserAvatarListExpanded () {
            this.isUserAvatarListExpanded = true;
        },
        onUserAvatarListCollapsed () {
            this.isUserAvatarListExpanded = false;
        }
    }
};
